import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  href: PropTypes.string.isRequired,
  verb: PropTypes.string,
  text: PropTypes.string,
  cssClass: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
});
